import PerfilNovo from './PerfilNovo';

export default PerfilNovo;